import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QualityGallery from "./components/QualityGallery";
import SourceGrid from "./components/SourceGrid";
import NewReleases from "./components/NewReleases";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "静漫天堂漫画 · 高清静态图源与画质精选",
  url: "https://picvault.github.io/",
  inLanguage: "zh-CN",
  description:
    "静漫天堂漫画静态资源库，汇集高清原图与优质图源页面，按画质精细筛选，方便漫画爱好者快速找到清晰静态漫画内容。",
  mainEntity: {
    "@type": "ItemList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "暮色剑客" },
      { "@type": "ListItem", position: 2, name: "焰行都市" },
      { "@type": "ListItem", position: 3, name: "云海幻境" },
    ],
  },
};

const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "静漫天堂的图源都是高清原图吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "是的。静漫天堂对入库内容按画质严格分级，覆盖 4K超清、超清与高清原图等多个档位，并支持按画质精细筛选，帮助你在不同设备上都获得清晰的静态漫画阅读体验。",
      },
    },
    {
      "@type": "Question",
      name: "分镜图源和原图有什么区别？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "分镜图源按连载顺序整理、对白完整，适合逐页阅读；原图则保留作品原始尺寸与细节，适合收藏与放大浏览。静漫天堂已将两者分别归档，你可按需选择。",
      },
    },
    {
      "@type": "Question",
      name: "新作上线的更新频率是怎样的？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "静漫天堂的「新作前线」栏目保持实时上新，热门连载通常会在更新后尽快完成画质筛选与入库，你可以在「新作速递」板块查看最新同步的章节与更新日期。",
      },
    },
  ],
};

function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <Navbar />
      <main>
        <Hero />
        <QualityGallery />
        <SourceGrid />
        <NewReleases />
        <About />
        <Testimonials />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default Home;